export enum TseReferenceType {
    CANCELLATION = '[0] = Cancellation',
    PREDECESSOR = '[1] = Predecessor',
}



